import React from 'react';

const LearnMoreReselling = () => {
  const steps = [
    { id: "01", title: "Vendor Partnerships", description: "We partner with all leading industry vendors to deliver best-in-class security solutions, implemented by our certified and highly experienced engineers." },
    { id: "02", title: "Design & Deployment", description: "From design to deployment, our team ensures seamless integration and optimal performance tailored to your environment." },
    { id: "03", title: "Proactive Support", description: "We provide real-time support to address issues proactively and offer comprehensive training to empower your team." },
    { id: "04", title: "Maximize Investment", description: "Our comprehensive training empowers your team with the knowledge and confidence to manage and maximize your security investments." }
  ];

  return (
    /* Changed bg-white to bg-[#020617] (or bg-black) */
    <section className="py-16 px-6">
      <div className="max-w-6xl mx-auto">
        
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12 border-b border-white/10 pb-8">
          <div className="max-w-xl">
            {/* Brightened Accent Color */}
            <h4 className="text-green-400 font-bold tracking-[0.2em] uppercase text-xs mb-3">
              Implementation & Support
            </h4>
            {/* Swapped text-slate-900 for text-white */}
            <h2 className="text-3xl lg:text-5xl font-black text-white leading-tight">
              Our Commitment to <br /> Your Success
            </h2>
          </div>
          {/* Swapped text-gray-600 for text-slate-400 */}
          <p className="text-slate-400 text-sm md:text-base max-w-xs leading-relaxed italic">
            "Optimized, integrated, and fully supported 24/7 security partnerships."
          </p>
        </div>

        {/* List Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10">
          {steps.map((step, index) => (
            <div 
              key={index} 
              className="group border-b border-white/5 py-8 transition-all duration-300 hover:bg-white/[0.02] px-4"
            >
              <div className="flex gap-6 items-start">
                {/* Number: High Contrast Green/Blue */}
                <span className="text-green-400 font-bold text-xl tabular-nums pt-1">
                  {step.id}
                </span>

                {/* Content */}
                <div>
                  {/* Title: Pure White */}
                  <h3 className="text-xl font-bold text-white group-hover:text-green-400 transition-colors mb-2">
                    {step.title}
                  </h3>
                  {/* Description: Slate-300 for readability on black */}
                  <p className="text-slate-300 text-sm md:text-base leading-relaxed opacity-80 group-hover:opacity-100 transition-opacity">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default LearnMoreReselling;